import React, { Fragment } from 'react'
import { host, hostSocket } from '../../../configuraciones';
import { withRouter } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux';
import estilos from './SolicitudComponent.module.css'
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import { Task, UploadFile } from '@mui/icons-material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import AssignmentIcon from '@mui/icons-material/Assignment';
import CheckCircle from '@mui/icons-material/CheckCircle';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from "@mui/material/TextField";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import esLocale from "date-fns/locale/es";
import { getInspectores, getInspectorById } from '../../../redux/DucksUnidadInspeccion/InspectoresDuck';
import { renderSolicitud, renderTipoSolicitud, colorByStatusSolicitud } from '../../UsuarioInspectorEnCampo/InspectorUtils/InspectorUtils'
import { insertSolicitud, updateSolicitud } from '../../../redux/DucksUnidadInspeccion/SolicitudesUIF01Duck';
import { Button } from '@mui/material';
import { ErrorMessage, Field, FieldArray, Form, Formik } from 'formik';
import { obtenerTodasLasSolicitudesWithStatusEnviado, AcualizarFormatoAccion, obetenerSolicitudDetalle, obetenerFormatoDetalle } from '../../../redux/AtencionAClienteDucks'
import { actualizarLoadingApp_true, actualizarLoadingApp_false } from '../../../redux/AppDucks';
import { getClienteByNumsocio } from '../../../redux/DucksBeneficiario/ClienteDucks';
import { getInstalacionesByCliente } from '../../../redux/DucksUnidadInspeccion/AsociadosDuck';
import { obtenerInformesByIdCliente, obtenerDictamenByIdCliente, obtenerEscritoByIdCliente, obtenerSolicitudByIdSolicitudFC01, obtenerDictamenByTipo } from '../../../redux/DucksUnidadInspeccion/DocumentosDuck';
import { getInformeByIdSolicitud } from '../../../redux/DucksUnidadInspeccion/InformeCumplimientoDuck';
import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '@mui/icons-material/Edit';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import estilosEditar from '../../UsuarioInspectorEnCampo/Asociados/Tabs/TabsInspeccionarComponent.module.css'

import { updateResponsables } from '../../../redux/DucksUnidadInspeccion/ResponsablesDuck';
import { insertResponsables } from '../../../redux/DucksUnidadInspeccion/ResponsablesDuck';
import { updateInstalacionHistorial } from '../../../redux/DucksUnidadInspeccion/InstalacionesHistorialDuck';
import { deleteResponsables } from '../../../redux/DucksUnidadInspeccion/ResponsablesDuck';
import { obtenerInspectorByIdLogin } from '../../../redux/DucksUnidadInspeccion/InspectoresDuck';
import { actualizarInforme } from '../../../redux/DucksUnidadInspeccion/ArchivosDuck';
import { obtenerFolioByID, actualizarFolio } from '../../../redux/DucksUnidadInspeccion/FoliosUIDuck';

import moment from 'moment'
import 'moment/locale/es'
import InformacionGeneralFormComponent from './ModificarInforme/InformacionGeneralFormComponent';
import ValidacionDomicilioFormComponent from './ModificarInforme/ValidacionDomicilioFormComponent';
import CoccionFormComponent from './ModificarInforme/ProcesosYEquipo/CoccionFormComponent';
import PesadoDeAgaveFormComponent from './ModificarInforme/ProcesosYEquipo/PesadoDeAgaveFormComponent';
import MoliendaFormComponent from './ModificarInforme/ProcesosYEquipo/MoliendaFormComponent';
import TabsRecepcionMateriaPrimaComponent from './ModificarInforme/TabsRecepcionMateriaPrimaComponent';
import TabsInspeccionarComponent from './ModificarInforme/TabsInspeccionarComponent';

function SolicitudComponent(props) {

    moment.locale('es')

    const id = useSelector(store => store.Usuario.tipoUsuario)

    const [openModalAsignarInspector, setOpenModalAsignarInspector] = React.useState(false);
    const [isReasignar, setIsReasignar] = React.useState(false);

    const handleOpenModalAsignarInspector = (opcion) => {
        dispatch(getInspectores()).then((res) => {
            setInspectores(res.payload.data.data)
        })
        if (opcion === 1) {
            setIsReasignar(false)
        } else {
            setIsReasignar(true)
        }
        setOpenModalAsignarInspector(true)
    };

    const handleCloseModalAsignarInspector = () => setOpenModalAsignarInspector(false);

    const [openModalReagendar, setOpenModalReagendar] = React.useState(false);
    const handleOpenModalReagendar = () => setOpenModalReagendar(true);
    const handleCloseModalReagendar = () => setOpenModalReagendar(false);

    const dispatch = useDispatch();

    const [inspectores, setInspectores] = React.useState([]);
    const solicitudes = useSelector(store => store.AtencionSolicitud.data)
    const currentUser = useSelector(store => store.Usuario.data)

    const [fechaSeleccionada, setFechaSeleccionada] = React.useState('');
    const [documentos, setDocumentos] = React.useState([]);
    const [dictamenes, setDictamenes] = React.useState([]);
    const [urlPDF, setUrlPDF] = React.useState('');
    const [urlImg, setUrlImage] = React.useState("")
    const [nombreFormato, setNombreFormato] = React.useState("");
    const [openModalSeleccionarInstalacion, setOpenModalSeleccionarInstalacion] = React.useState(false);
    const [openModalSeleccionarDocumento, setOpenModalSeleccionarDocumento] = React.useState(false);
    const [openModalSeleccionarDictamen, setOpenModalSeleccionarDictamen] = React.useState(false);
    const [openModalVisualizar, setOpenModalVisualizar] = React.useState(false);
    const [openModalResponsable, setOpenModalRespobsable] = React.useState(false);
    const [openModalSeleccionarInforme, setOpenModalSeleccionarInforme] = React.useState(false);
    const [openEditarDictamen, setOpenEditarDictamen] = React.useState(false);
    const [openSubirInforme, setOpenSubirInforme] = React.useState(false);

    const [tipoInstalacion, setTipoInstalacion] = React.useState();

    const [informacionEditar, setInformacionEditar] = React.useState([]);
    const [dictamenEditando, setDictamenEditando] = React.useState({
        fi_25_caratula: [{
            fi_25_anexo_instalacion_historial: [{}]
        }]
    });

    const [responsables, setResponsables] = React.useState([]);

    const [informeSeleccionado, setInformeSeleccionado] = React.useState(null);

    const tipo = props.tipo; const status = props.status; const user = props.user; const solicitud = props.solicitud; const index = props.index;

    const usuario = useSelector(store => store.Usuario)
    const idUsuario = usuario.data.user[0]

    const [informacionFormik, setInformacionFormik] = React.useState(
        {
            folio: "",
            escrito: "",
            inspectorseleccionado: "",
            fecha: "",
        }
    );

    const style = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 800,
        bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24, p: 4,
    };

    const styleResponsable = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 900,
        bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24, p: 4,
    };

    const styleEditarDictamen = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 1000, height: 600,
        bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24, p: 4,
    };

    const styleSubir = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 500,
        bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24, p: 4,
    };

    const stylePrev = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 1000,
        height: 550,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    const styleNormal = {
        "& legend": { display: "none" },
        "& fieldset": { top: 0 },
        background: "white",
    };

    React.useEffect(() => {
        if (solicitud.solicitudesuifc01.length > 0) {
            setFechaSeleccionada(solicitud.solicitudesuifc01[0].fecharealdeinspeccion)
            setInformacionFormik({
                folio: solicitud.solicitudesuifc01[0].folioui,
                escrito: solicitud.solicitudesuifc01[0].ncomision,
                inspectorseleccionado: solicitud.solicitudesuifc01[0].inspector.idinspector,
                fecha: solicitud.solicitudesuifc01[0].fecharealdeinspeccion,
            })
        }
    }, []);

    React.useEffect(() => {
        inspectores
    }, [inspectores])

    const reagendarSolicitud = () => {
        let fecha = new Date(fechaSeleccionada);
        fecha.setDate(fecha.getDate() - 1);
        const data = {
            data: {
                idsolicitudesuifc01: Number(solicitud.solicitudesuifc01[0].idsolicitudesuifc01),
                idinspector: Number(solicitud.solicitudesuifc01[0].idinspector),
                idfc01_solicitudregistro: Number(solicitud.solicitudesuifc01[0].idfc01_solicitudregistro),
                fecharealdeinspeccion: fecha,
                asignadopor: solicitud.solicitudesuifc01[0].asignadopor,
                statusdelasolicitud: solicitud.solicitudesuifc01[0].statusdelasolicitud
            }
        }
        dispatch(updateSolicitud(data))
    }

    const verSolicitud = async () => {
        dispatch(obtenerSolicitudByIdSolicitudFC01(solicitud.idfc01_solicitudregistro)).then((response) => {
            setDocumentos(response.payload.data.data)
            handleOpenModalSeleccionarDocumento()
        })
    }

    const verEscrito = async () => {
        dispatch(obtenerEscritoByIdCliente(solicitud.solicitudesuifc01[0].idsolicitudesuifc01)).then((response) => {
            setDocumentos(response.payload.data.data)
            handleOpenModalSeleccionarDocumento()
        })
    }

    const separarInstalaciones = (tipoinstalacion, res) => {
        let instalaciones = []

        if (tipoinstalacion === 1) {
            res.forEach((i) => {
                if (i.idtipoanexo === 1) {
                    instalaciones.push(i.informaciongeneralinstalacioncliente)
                }
            })
        }

        if (tipoinstalacion === 2) {
            res.forEach((i) => {
                if (i.idtipoanexo === 2) {
                    instalaciones.push(i.informaciongeneralinstalacioncliente)
                }
            })
        }

        if (tipoinstalacion === 3) {
            res.forEach((i) => {
                if (i.idtipoanexo === 3) {
                    instalaciones.push(i.informaciongeneralinstalacioncliente)
                }
            })
        }

        return instalaciones;
    }

    const generarDictamen = async (tipoinstalacion, isUpdate) => {
        await dispatch(actualizarLoadingApp_true())
        handleCloseModalSeleccionarInstalacion()
        dispatch(getInspectores()).then((i) => {
            setInspectores(i.payload.data.data)
        })
        dispatch(obtenerFolioByID(1)).then((resfolio) => {
            let folio = resfolio.payload.data.data[0]
            dispatch(getInformeByIdSolicitud(solicitud.idfc01_solicitudregistro)).then((responseinforme) => {

                var informe = responseinforme.payload.data.data

                dispatch(getInstalacionesByCliente(1)).then((responseinstalacion) => {
                    let resins = responseinstalacion.payload.data.data;

                    let instalaciones = separarInstalaciones(tipoinstalacion, resins)

                    dispatch(getClienteByNumsocio(solicitud.numerosocio)).then(async (cliente) => {
                        dispatch(getInspectorById(solicitud.solicitudesuifc01[0].idinspector)).then(async (responseinspector) => {
                            dispatch(obtenerInspectorByIdLogin(currentUser.user[0].id)).then(async (gerente) => {
                                let nombreGerente = gerente.payload.data.data.titulo + ". " + gerente.payload.data.data.nombre + " " + gerente.payload.data.data.apellidos;
                                inspectores.forEach((e) => {
                                    if (e.login != null) {
                                        if (e.login.idlogin === idUsuario.id) {
                                            nombreGerente = e.titulo + ". " + e.nombre + " " + e.apellidos
                                        }
                                    }
                                })

                                let nombreInspector;
                                let apellidosInspector;
                                nombreInspector = responseinspector.payload.data.data.nombre.split(" ")
                                apellidosInspector = responseinspector.payload.data.data.apellidos.split(" ")

                                let nombreArchivo = "FI02-";

                                const fecha = Date.now();
                                const hoy = new Date(fecha);

                                let anio = hoy.getFullYear();
                                let mes = hoy.getMonth() + 1;
                                let dia = hoy.getDate();

                                dia = ('0' + dia).slice(-2);
                                mes = ('0' + mes).slice(-2);

                                let anios = String(anio)
                                let fechaForm = dia + "" + mes + "" + anios[2] + anios[3];
                                let fechaForm2 = dia + "/" + mes + "/" + anios[2] + anios[3];
                                let inicialesInspector = "";

                                for (let i = 0; i < nombreInspector.length; i++) {
                                    inicialesInspector += nombreInspector[i][0]
                                }

                                for (let i = 0; i < apellidosInspector.length; i++) {
                                    inicialesInspector += apellidosInspector[i][0]
                                }

                                nombreArchivo += solicitud.numerosocio + "-" + "." + anios[2] + anios[3] + "-" + fechaForm + inicialesInspector + ".pdf"

                                let data = {}

                                if (isUpdate == true) {
                                    console.log(solicitud.solicitudesuifc01[0].idsolicitudesuifc01)
                                    let dataDictamen = {
                                        id: solicitud.solicitudesuifc01[0].idsolicitudesuifc01,
                                        tipo: tipoinstalacion
                                    }
                                    console.log(dataDictamen)
                                    dispatch(obtenerDictamenByTipo(dataDictamen)).then(async (resdictn) => {
                                        data = {
                                            numeroDeDictamen: folio.folio,
                                            razonSocial: solicitud.nombrerazonsocial,
                                            nombregerente: nombreGerente,
                                            idcliente: cliente.payload.data.data.idcliente,
                                            nombreArchivo: nombreArchivo,
                                            instalaciones: instalaciones,
                                            tipoinstalacion: tipoinstalacion,
                                            idsolicitudesuifc01: solicitud.solicitudesuifc01[0].idsolicitudesuifc01,
                                            numeroasociado: solicitud.numerosocio,
                                            fechaemision: hoy,
                                            ninforme: solicitud.solicitudesuifc01[0].ncomision,
                                            fechainspeccion: solicitud.solicitudesuifc01[0].fecharealdeinspeccion,
                                            informe: informe,
                                            isUpdate: true,
                                            idinspector: gerente.payload.data.data.idinspector,
                                            folio: folio.folio,
                                            folioantiguo: resdictn.payload.data.data.folio
                                        };

                                        const documento = await fetch(host + 'ArchivosUnidadInspeccion/generarDictamen', {
                                            method: 'POST',
                                            mode: 'cors',
                                            body: JSON.stringify(data),
                                            headers: new Headers({
                                                'Content-Type': 'application/json',
                                                'Access-Control-Allow-Origin': '*',
                                            }),
                                        })

                                        const dataSolicitud = {
                                            data: {
                                                idsolicitudesuifc01: solicitud.solicitudesuifc01[0].idsolicitudesuifc01,
                                                idinspector: solicitud.solicitudesuifc01[0].idinspector,
                                                idfc01_solicitudregistro: Number(solicitud.idfc01_solicitudregistro),
                                                fecharealdeinspeccion: solicitud.solicitudesuifc01[0].fecharealdeinspeccion,
                                                asignadopor: solicitud.solicitudesuifc01[0].asignadopor,
                                                statusdelasolicitud: 4,
                                                folioui: solicitud.solicitudesuifc01[0].folioui,
                                                ncomision: solicitud.solicitudesuifc01[0].ncomision
                                            }
                                        }
                                        //dispatch(updateSolicitud(dataSolicitud))

                                        if (documento.status != 404) {
                                            const blob = await documento.blob();
                                            const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
                                            //window.open(url);
                                            setUrlPDF(url)
                                            let a = document.createElement("a");
                                            a.href = url;
                                            a.download = nombreArchivo;
                                            a.click()
                                            if (props.isCalendario === false && isUpdate == false) {
                                                props.actualizarSolicitudes();
                                                //props.dictamenemitido()
                                            } else if (props.isCalendario === false && isUpdate == true) {
                                                props.actualizarSolicitudes();
                                                //props.completadas();
                                            } else if (props.isCalendario === true) {
                                                props.actualizarSolicitudes();
                                                props.handleCloseModalSolicitudes()
                                            }
                                            if (props.isZonas === true) {
                                                props.actualizarSolicitudes()
                                                props.handleCerrarModalSolicitudes()
                                            }

                                            await dispatch(actualizarLoadingApp_false())
                                        } else {

                                        }
                                    })

                                } else if (isUpdate != true) {
                                    data = {
                                        numeroDeDictamen: folio.folio,
                                        razonSocial: solicitud.nombrerazonsocial,
                                        nombregerente: nombreGerente,
                                        idcliente: cliente.payload.data.data.idcliente,
                                        nombreArchivo: nombreArchivo,
                                        instalaciones: instalaciones,
                                        tipoinstalacion: tipoinstalacion,
                                        idsolicitudesuifc01: solicitud.solicitudesuifc01[0].idsolicitudesuifc01,
                                        numeroasociado: solicitud.numerosocio,
                                        fechaemision: hoy,
                                        ninforme: solicitud.solicitudesuifc01[0].ncomision,
                                        fechainspeccion: solicitud.solicitudesuifc01[0].fecharealdeinspeccion,
                                        informe: informe,
                                        isUpdate: false,
                                        idinspector: gerente.payload.data.data.idinspector,
                                        folio: folio.folio
                                    };

                                    const documento = await fetch(host + 'ArchivosUnidadInspeccion/generarDictamen', {
                                        method: 'POST',
                                        mode: 'cors',
                                        body: JSON.stringify(data),
                                        headers: new Headers({
                                            'Content-Type': 'application/json',
                                            'Access-Control-Allow-Origin': '*',
                                        }),
                                    })

                                    const dataSolicitud = {
                                        data: {
                                            idsolicitudesuifc01: solicitud.solicitudesuifc01[0].idsolicitudesuifc01,
                                            idinspector: solicitud.solicitudesuifc01[0].idinspector,
                                            idfc01_solicitudregistro: Number(solicitud.idfc01_solicitudregistro),
                                            fecharealdeinspeccion: solicitud.solicitudesuifc01[0].fecharealdeinspeccion,
                                            asignadopor: solicitud.solicitudesuifc01[0].asignadopor,
                                            statusdelasolicitud: 4,
                                            folioui: solicitud.solicitudesuifc01[0].folioui,
                                            ncomision: solicitud.solicitudesuifc01[0].ncomision
                                        }
                                    }
                                    //dispatch(updateSolicitud(dataSolicitud))

                                    if (documento.status != 404) {
                                        const blob = await documento.blob();
                                        const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
                                        //window.open(url);
                                        setUrlPDF(url)
                                        let a = document.createElement("a");
                                        a.href = url;
                                        a.download = nombreArchivo;
                                        a.click()
                                        if (props.isCalendario === false && isUpdate == false) {
                                            props.actualizarSolicitudes();
                                            //props.dictamenemitido()
                                        } else if (props.isCalendario === false && isUpdate == true) {
                                            props.actualizarSolicitudes();
                                            //props.completadas();
                                        } else if (props.isCalendario === true) {
                                            props.actualizarSolicitudes();
                                            props.handleCloseModalSolicitudes()
                                        }
                                        if (props.isZonas === true) {
                                            props.actualizarSolicitudes()
                                            props.handleCerrarModalSolicitudes()
                                        }

                                        await dispatch(actualizarLoadingApp_false())
                                    } else {

                                    }
                                }
                            })
                        })
                    })
                })
            })

            let nuevoFolio = Number(folio.folio) + 1

            const data = {
                data: {
                    idfolio: folio.idfolio,
                    folio: nuevoFolio.toString(),
                    descripcion: folio.descripcion
                }
            }
            dispatch(actualizarFolio(data))
        })
    }

    const corregirDictamen = (tipo) => {
        setTipoInstalacion(tipo)
        dispatch(getInformeByIdSolicitud(solicitud.idfc01_solicitudregistro)).then((response) => {
            setInformacionEditar(response.payload.data.data.filter(i => i.informaciongeneralinstalacioncliente.anexocliente[0].idtipoanexo == tipo))
            handleOpenSeleccionarInforme()
        })

    }

    React.useEffect(() => {
        informacionEditar
    }, [informacionEditar])

    React.useEffect(() => {
        documentos
    }, [documentos])

    const verInforme = async () => {
        dispatch(getClienteByNumsocio(solicitud.numerosocio)).then((response) => {
            dispatch(obtenerInformesByIdCliente(solicitud.solicitudesuifc01[0].idsolicitudesuifc01)).then(async (response) => {
                setDocumentos(response.payload.data.data)
                handleOpenModalSeleccionarDocumento()
            })
        })
    }

    const visualizarInforme = async (ruta) => {
        //await dispatch(actualizarLoadingApp_true())
        let urlImg = hostSocket + "/";
        //PARA UBUNTU REMPLAZAR POR /
        let array = ruta.split("/")
        let empieza = 0;
        for (let i = 0; i < array.length; i++) {
            if (array[i] === 'docs') {
                empieza = i;
                break;
            }
        }
        for (let j = empieza; j < array.length; j++) {
            if (j === array.length - 1) {
                urlImg += array[j]
            } else {
                urlImg += array[j] + "/"
            }
        }
        await dispatch(actualizarLoadingApp_false())

        handleCloseModalSeleccionarDocumento()
        setUrlPDF(urlImg)
        window.open(urlImg)
        //handleOpenModalPrevisualizar()

    }

    const actualizarEstado2 = () => {
        if (solicitud.solicitudesuifc01[0].statusdelasolicitud === 2) {
            const dataSolicitud = {
                data: {
                    idsolicitudesuifc01: solicitud.solicitudesuifc01[0].idsolicitudesuifc01,
                    idinspector: solicitud.solicitudesuifc01[0].idinspector,
                    idfc01_solicitudregistro: Number(solicitud.idfc01_solicitudregistro),
                    fecharealdeinspeccion: solicitud.solicitudesuifc01[0].fecharealdeinspeccion,
                    asignadopor: solicitud.solicitudesuifc01[0].asignadopor,
                    statusdelasolicitud: 3,
                    folioui: solicitud.solicitudesuifc01[0].folioui,
                    ncomision: solicitud.solicitudesuifc01[0].ncomision
                }
            }
            dispatch(updateSolicitud(dataSolicitud))
            if (props.isCalendario === false) {
                props.actualizarSolicitudes();
                props.informerevision();
            } else if (props.isCalendario === true) {
                props.actualizarSolicitudes();
                props.handleCloseModalSolicitudes()
            }

            if (props.isZonas === true) {
                props.actualizarSolicitudes()
                props.handleCerrarModalSolicitudes()
            }

        }
    }

    const actualizarEstado3 = () => {
        const dataSolicitud = {
            data: {
                idsolicitudesuifc01: solicitud.solicitudesuifc01[0].idsolicitudesuifc01,
                idinspector: solicitud.solicitudesuifc01[0].idinspector,
                idfc01_solicitudregistro: Number(solicitud.idfc01_solicitudregistro),
                fecharealdeinspeccion: solicitud.solicitudesuifc01[0].fecharealdeinspeccion,
                asignadopor: solicitud.solicitudesuifc01[0].asignadopor,
                statusdelasolicitud: 4,
                folioui: solicitud.solicitudesuifc01[0].folioui,
                ncomision: solicitud.solicitudesuifc01[0].ncomision
            }
        }
        dispatch(updateSolicitud(dataSolicitud))

        if (props.isCalendario === false) {
            props.actualizarSolicitudes();
            props.dictamenemitido()
        } else if (props.isCalendario === true) {
            props.actualizarSolicitudes();
            props.handleCloseModalSolicitudes()
        }

        if (props.isZonas === true) {
            props.actualizarSolicitudes()
            props.handleCerrarModalSolicitudes()
        }
    }

    const actualizarEstado4 = () => {
        if (solicitud.solicitudesuifc01[0].statusdelasolicitud === 4) {
            const dataSolicitud = {
                data: {
                    idsolicitudesuifc01: solicitud.solicitudesuifc01[0].idsolicitudesuifc01,
                    idinspector: solicitud.solicitudesuifc01[0].idinspector,
                    idfc01_solicitudregistro: Number(solicitud.idfc01_solicitudregistro),
                    fecharealdeinspeccion: solicitud.solicitudesuifc01[0].fecharealdeinspeccion,
                    asignadopor: solicitud.solicitudesuifc01[0].asignadopor,
                    statusdelasolicitud: 5,
                    folioui: solicitud.solicitudesuifc01[0].folioui,
                    ncomision: solicitud.solicitudesuifc01[0].ncomision
                }
            }
            dispatch(updateSolicitud(dataSolicitud))
            if (props.isCalendario === false) {
                props.actualizarSolicitudes();
                props.completadas();
            } else if (props.isCalendario === true) {
                props.actualizarSolicitudes();
                props.handleCloseModalSolicitudes()
            }

            if (props.isZonas === true) {
                props.actualizarSolicitudes()
                props.handleCerrarModalSolicitudes()
            }

        }
    }

    const actualizarEstado5 = () => {
        if (solicitud.solicitudesuifc01[0].statusdelasolicitud === 6) {
            const dataSolicitud = {
                data: {
                    idsolicitudesuifc01: solicitud.solicitudesuifc01[0].idsolicitudesuifc01,
                    idinspector: solicitud.solicitudesuifc01[0].idinspector,
                    idfc01_solicitudregistro: Number(solicitud.idfc01_solicitudregistro),
                    fecharealdeinspeccion: solicitud.solicitudesuifc01[0].fecharealdeinspeccion,
                    asignadopor: solicitud.solicitudesuifc01[0].asignadopor,
                    statusdelasolicitud: 5,
                    folioui: solicitud.solicitudesuifc01[0].folioui,
                    ncomision: solicitud.solicitudesuifc01[0].ncomision
                }
            }
            dispatch(updateSolicitud(dataSolicitud))
            if (props.isCalendario === false) {
                props.actualizarSolicitudes();
                props.completadas();
            } else if (props.isCalendario === true) {
                props.actualizarSolicitudes();
                props.handleCloseModalSolicitudes()
            }

            if (props.isZonas === true) {
                props.actualizarSolicitudes()
                props.handleCerrarModalSolicitudes()
            }

        }
    }

    const verDictamen = async () => {
        dispatch(getClienteByNumsocio(solicitud.numerosocio)).then((response) => {
            dispatch(obtenerDictamenByIdCliente(solicitud.solicitudesuifc01[0].idsolicitudesuifc01)).then(async (response) => {
                setDictamenes(response.payload.data.data)
                handleOpenModalSeleccionarDictamen()
            })
        })
    }

    const visualizarDictamen = async (ruta) => {
        await dispatch(actualizarLoadingApp_true())
        let urlImg = hostSocket + "/";
        //PARA UBUNTU REMPLAZAR POR /
        let array = ruta.split("/")
        let empieza = 0;
        for (let i = 0; i < array.length; i++) {
            if (array[i] === 'docs') {
                empieza = i;
                break;
            }
        }
        for (let j = empieza; j < array.length; j++) {
            if (j === array.length - 1) {
                urlImg += array[j]
            } else {
                urlImg += array[j] + "/"
            }
        }
        handleCloseModalSeleccionarDictamen()
        await dispatch(actualizarLoadingApp_false())
        setUrlPDF(urlImg)
        window.open(urlImg)
        // if (solicitud.solicitudesuifc01[0].statusdelasolicitud === 4) {
        //     const dataSolicitud = {
        //         data: {
        //             idsolicitudesuifc01: solicitud.solicitudesuifc01[0].idsolicitudesuifc01,
        //             idinspector: solicitud.solicitudesuifc01[0].idinspector,
        //             idfc01_solicitudregistro: Number(solicitud.idfc01_solicitudregistro),
        //             fecharealdeinspeccion: solicitud.solicitudesuifc01[0].fecharealdeinspeccion,
        //             asignadopor: solicitud.solicitudesuifc01[0].asignadopor,
        //             statusdelasolicitud: 5,
        //             folioui: solicitud.solicitudesuifc01[0].folioui,
        //             ncomision: solicitud.solicitudesuifc01[0].ncomision
        //         }
        //     }
        //     //dispatch(updateSolicitud(dataSolicitud))
        //     if (props.isCalendario === false) {
        //         props.actualizarSolicitudes();
        //         //props.completadas();
        //     } else if (props.isCalendario === true) {
        //         props.actualizarSolicitudes();
        //         props.handleCloseModalSolicitudes()
        //     }
        //     if (props.isZonas === true) {
        //         props.actualizarSolicitudes()
        //         props.handleCerrarModalSolicitudes()
        //     }

        // }
        //handleOpenModalPrevisualizar()
    }

    const handleOpenModalEditarDictamen = (e) => {
        setDictamenEditando(e)
        setResponsables(e.fi_25_caratula[0].fi_25_responsables)
        setOpenEditarDictamen(true)
    }

    const handleCloseModalEditarDictamen = () => {
        setOpenEditarDictamen(false)
    }

    const handleOpenModalResponsable = () => {
        setOpenModalRespobsable(true);
    }
    const handleCloseModalRespobsable = () => {
        setOpenModalRespobsable(false);
    }

    const handleEliminarResponsable = (elemento) => {
        let responsable = responsables.filter((r) => r !== elemento);
        setResponsables(responsable);
    }

    const modalEditarDictamen = () => {
        return (
            <Modal
                open={openEditarDictamen}
                onClose={handleCloseModalEditarDictamen}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleEditarDictamen} style={{ overflowY: 'scroll' }}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Editar Informacion
                    </Typography>
                    <br />
                    <TabsInspeccionarComponent tipo={tipoInstalacion} informe={dictamenEditando} solicitud={solicitud} />

                </Box>
            </Modal>
        )
    }



    const handleNuevoResponsable = (valores) => {
        setResponsables([...responsables,
        {
            correoelectronico: valores.correoelectronico,
            edad: valores.edad,
            email: valores.email,
            nombre: valores.nombreresponsable,
            telefono: valores.telefono,
        }])
        handleCloseModalRespobsable();

    }

    const modalComponentResponsable = () => {
        return (
            <div>
                <Modal
                    open={openModalResponsable}
                    onClose={handleCloseModalRespobsable}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={styleResponsable}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <div style={{ textAlign: "center" }}>
                                Nuevo Responsable
                            </div>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            <Formik
                                initialValues={{
                                    responsable: '',
                                    edad: '',
                                    telefono: '',
                                    email: ''
                                }}
                                enableReinitialize
                                validate={(valores) => {
                                    let errores = {};

                                    if (!valores.nombreresponsable) {
                                        errores.nombreresponsable = 'Por favor ingresa el nombre del responsable'
                                    }

                                    if (!valores.edad) {
                                        errores.edad = 'Por favor ingresa una edad'
                                    }

                                    if (!valores.telefono) {
                                        errores.telefono = 'Por favor ingresa un telefono'
                                    }

                                    if (!valores.correoelectronico) {
                                        errores.correoelectronico = 'Por favor ingresa un correo electronico'
                                    }

                                    return errores;
                                }}
                                onSubmit={(valores) => {
                                    handleNuevoResponsable(valores)
                                }}
                            >
                                {(props) => (
                                    <Form>
                                        <div className='row'>
                                            <div className="col-md-4 mb-3">
                                                <label htmlFor="responsable">Responsable de las Instalaciones</label>
                                                <Field type="text" className="form-control form-control-sm" id="nombreresponsable" name="nombreresponsable" placeholder="Responsable de las Instalaciones" required></Field>
                                                <ErrorMessage name='nombreresponsable' component={() => (
                                                    <div className={`${estilos.error}`}>{props.errors.nombreresponsable}</div>
                                                )} />
                                            </div>
                                            <div className="col-md-1 mb-3">
                                                <label htmlFor="edad">Edad</label>
                                                <Field type="number" className="form-control form-control-sm" id="edad" name="edad" placeholder="0" required></Field>
                                                <ErrorMessage name='edad' component={() => (
                                                    <div className={`${estilos.error}`}>{props.errors.edad}</div>
                                                )} />
                                            </div>
                                            <div className="col mb-3">
                                                <label htmlFor="telefono">Telefono</label>
                                                <Field type="phone" className="form-control form-control-sm" id="telefono" name="telefono" placeholder="Telefono" required></Field>
                                                <ErrorMessage name='telefono' component={() => (
                                                    <div className={`${estilos.error}`}>{props.errors.telefono}</div>
                                                )} />
                                            </div>
                                            <div className="col mb-3">
                                                <label htmlFor="email">Correo Electronico</label>
                                                <Field type="email" className="form-control form-control-sm" id="correoelectronico" name="correoelectronico" placeholder="Correo Electronico" required></Field>
                                                <ErrorMessage name='correoelectronico' component={() => (
                                                    <div className={`${estilos.error}`}>{props.errors.correoelectronico}</div>
                                                )} />
                                            </div>
                                        </div>
                                        <div style={{ textAlign: "center" }}>
                                            <button type='submit' className="btn btn-success">GUARDAR</button>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </Typography>
                        <br />

                    </Box>
                </Modal>
            </div>
        )
    }

    const handleOpenSeleccionarInforme = () => {
        setOpenModalSeleccionarInforme(true)
    }

    const handleCloseSeleccionarInforme = () => {
        setOpenModalSeleccionarInforme(false)
    }

    const modalSeleccionarInforme = () => {
        return (
            <Modal
                open={openModalSeleccionarInforme}
                onClose={handleCloseSeleccionarInforme}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Selecciona la instalación
                    </Typography>
                    <div className='table-responsive'>
                        <table className='table table-striped table-hover'>
                            <thead>
                                <tr>
                                    <th>
                                        Alias
                                    </th>
                                    <th>
                                        Tipo Unidad
                                    </th>
                                    <th>
                                        Acciones
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {informacionEditar.map((i) => {
                                    return (
                                        <Fragment>
                                            <tr>
                                                <td>
                                                    {i.informaciongeneralinstalacioncliente.alias}
                                                </td>
                                                <td>
                                                    {i.informaciongeneralinstalacioncliente.anexocliente[0].idtipoanexo == 1 ? 'Producción' : i.informaciongeneralinstalacioncliente.anexocliente[0].idtipoanexo == 2 ? 'Envasado' : i.informaciongeneralinstalacioncliente.anexocliente[0].idtipoanexo == 3 ? 'Almacen' : ''}
                                                </td>
                                                <td>
                                                    <button className='btn btn-danger' onClick={() => handleOpenModalEditarDictamen(i)}><strong>Modificar</strong></button>
                                                </td>
                                            </tr>
                                        </Fragment>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>

                </Box>
            </Modal>
        )
    }

    const [openModalTipoInstalacionInforme, setOpenModalTipoInstalacionInforme] = React.useState(false);

    const handleOpenModalTipoInstalacionInforme = () => {
        setOpenModalTipoInstalacionInforme(true)
    }

    const handleCloseModalTipoInstalacionInforme = () => {
        setOpenModalTipoInstalacionInforme(false)
    }

    const modalSeleccionarTipoInstalacionInforme = () => {
        return (
            <Modal
                open={openModalTipoInstalacionInforme}
                onClose={handleCloseModalTipoInstalacionInforme}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Selecciona la instalación
                    </Typography>
                    <div className='table-responsive'>
                        <table className='table table-striped table-hover'>
                            <thead>
                                <tr>
                                    <th>
                                        Tipo de Dictamen
                                    </th>
                                    <th>
                                        Acciones
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        Producción
                                    </td>
                                    <td>
                                        <button className='btn btn-success' onClick={() => corregirDictamen(1)}><strong>Modificar</strong></button>
                                    </td>
                                    <td>
                                        <button className='btn btn-danger' onClick={() => generarDictamen(1, true)}><strong>Generar Dictamen</strong></button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Envasado
                                    </td>
                                    <td>
                                        <button className='btn btn-success' onClick={() => corregirDictamen(2)}><strong>Modificar</strong></button>
                                    </td>
                                    <td>
                                        <button className='btn btn-danger' onClick={() => generarDictamen(2, true)}><strong>Generar Dictamen</strong></button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Almacen
                                    </td>
                                    <td>
                                        <button className='btn btn-success' onClick={() => corregirDictamen(3)}><strong>Modificar</strong></button>
                                    </td>
                                    <td>
                                        <button className='btn btn-danger' onClick={() => generarDictamen(3, true)}><strong>Generar Dictamen</strong></button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </Box>
            </Modal>
        )
    }

    const modalAsignarInspector = () => {
        return (
            <Modal
                open={openModalAsignarInspector}
                onClose={handleCloseModalAsignarInspector}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Asignar Inspector
                    </Typography>
                    <br />

                    <Formik
                        initialValues={informacionFormik}
                        enableReinitialize
                        onSubmit={async (values) => {
                            //console.log(inspectores)
                            /*

                                1.- si no ha pasado el inspector: pendiente inspeccion.
                                2.- si ya paso el inspector: informe emitido.
                                3.- si esta en proceso de revision del informe: informe en revisión.
                                4.- Si ya lo reviso el gerente: dictamen emitido.
                                    cuando se finalize todo el proceso: Solictud atendida

                            */

                            let nombre = "";
                            inspectores.forEach((e) => {
                                if (e.login != null) {
                                    if (e.login.idlogin === idUsuario.id) {
                                        nombre = e.nombre + " " + e.apellidos
                                    }
                                }
                            })

                            let nombreIns = "";

                            inspectores.forEach((e) => {
                                if (e.idinspector === Number(values.inspectorseleccionado)) {
                                    nombreIns = e.nombre + " " + e.apellidos
                                }
                            })

                            if (isReasignar === true) {

                                let fecha = new Date(fechaSeleccionada);
                                fecha.setDate(fecha.getDate() - 1);

                                const data = {
                                    data: {
                                        idsolicitudesuifc01: solicitud.solicitudesuifc01[0].idsolicitudesuifc01,
                                        idinspector: Number(values.inspectorseleccionado),
                                        idfc01_solicitudregistro: Number(solicitud.idfc01_solicitudregistro),
                                        fecharealdeinspeccion: fecha,
                                        asignadopor: nombre,
                                        statusdelasolicitud: 1,
                                        folioui: values.folio,
                                        ncomision: values.escrito,
                                        isoffline: false
                                    }
                                }
                                dispatch(updateSolicitud(data))
                                dispatch(getClienteByNumsocio(solicitud.numerosocio)).then(async (a) => {
                                    dispatch(getInspectorById(values.inspectorseleccionado)).then(async (response) => {
                                        dispatch(obtenerInspectorByIdLogin(currentUser.user[0].id)).then(async (gerente) => {
                                            let nombreInspector;
                                            let apellidosInspector;
                                            nombreInspector = response.payload.data.data.nombre.split(" ")
                                            apellidosInspector = response.payload.data.data.apellidos.split(" ")

                                            let nombreArchivo = "FI01-";

                                            const fecha = Date.now();
                                            const hoy = new Date(fecha);

                                            let anio = hoy.getFullYear();
                                            let mes = hoy.getMonth() + 1;
                                            let dia = hoy.getDate();

                                            dia = ('0' + dia).slice(-2);
                                            mes = ('0' + mes).slice(-2);

                                            let anios = String(anio)
                                            let fechaForm = dia + "" + mes + "" + anios[2] + anios[3];
                                            let fechaForm2 = dia + "/" + mes + "/" + anios[2] + anios[3];
                                            let inicialesInspector = "";

                                            for (let i = 0; i < nombreInspector.length; i++) {
                                                inicialesInspector += nombreInspector[i][0]
                                            }

                                            for (let i = 0; i < apellidosInspector.length; i++) {
                                                inicialesInspector += apellidosInspector[i][0]
                                            }

                                            nombreArchivo += solicitud.numerosocio + "-" + values.escrito + "." + anios[2] + anios[3] + fechaForm + inicialesInspector + ".pdf"

                                            let nombregerente = gerente.payload.data.data.titulo + ". " + gerente.payload.data.data.nombre + " " + gerente.payload.data.data.apellidos


                                            const data = {
                                                numeroDeEscritoComision: values.escrito,
                                                fecha: fechaForm2,
                                                nombreDelCliente: solicitud.nombrerazonsocial,
                                                domicilioDelInstalacion: solicitud.calle + " " + solicitud.numeroexterior + " " + solicitud.municipioalcaldia + " " + solicitud.estado,
                                                telefono: solicitud.telefono,
                                                nombreInspector: nombreIns,
                                                idsolicitudesuifc01: solicitud.solicitudesuifc01[0].idsolicitudesuifc01,
                                                idcliente: a.payload.data.data.idcliente,
                                                nombreArchivo: nombreArchivo,
                                                reasignar: true,
                                                idinspector: gerente.payload.data.data.idinspector,
                                                nombregerente: nombregerente
                                            };
                                            const documento = await fetch(host + 'ArchivosUnidadInspeccion/actualizarEscritoDeComision', {
                                                method: 'POST',
                                                mode: 'cors',
                                                body: JSON.stringify(data),
                                                headers: new Headers({
                                                    'Content-Type': 'application/json',
                                                    'Access-Control-Allow-Origin': '*',
                                                }),
                                            })

                                            if (documento.status != 404) {
                                                const blob = await documento.blob();
                                                const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
                                                //window.open(url);
                                                setUrlPDF(url)
                                                let a = document.createElement("a");
                                                a.href = url;
                                                a.download = nombreArchivo;
                                                a.click()
                                                if (props.isCalendario === false) {
                                                    props.actualizarSolicitudes();
                                                } else if (props.isCalendario === true) {
                                                    props.actualizarSolicitudes();
                                                    props.handleCloseModalSolicitudes()
                                                }

                                                if (props.isZonas === true) {
                                                    props.actualizarSolicitudes()
                                                    props.handleCerrarModalSolicitudes()
                                                }

                                                await dispatch(actualizarLoadingApp_false())
                                            } else {

                                            }
                                        })
                                    })
                                })

                            } else {
                                const data = {
                                    data: {
                                        idinspector: Number(values.inspectorseleccionado),
                                        idfc01_solicitudregistro: Number(solicitud.idfc01_solicitudregistro),
                                        fecharealdeinspeccion: fechaSeleccionada,
                                        asignadopor: nombre,
                                        statusdelasolicitud: 1,
                                        folioui: values.folio,
                                        ncomision: values.escrito,
                                        isoffline: false
                                    }
                                }
                                dispatch(insertSolicitud(data)).then(async (r) => {
                                    dispatch(getClienteByNumsocio(solicitud.numerosocio)).then(async (a) => {
                                        dispatch(getInspectorById(values.inspectorseleccionado)).then(async (response) => {
                                            dispatch(obtenerInspectorByIdLogin(currentUser.user[0].id)).then(async (gerente) => {
                                                let nombreInspector;
                                                let apellidosInspector;
                                                nombreInspector = response.payload.data.data.nombre.split(" ")
                                                apellidosInspector = response.payload.data.data.apellidos.split(" ")

                                                let nombreArchivo = "FI01-";

                                                const fecha = Date.now();
                                                const hoy = new Date(fecha);

                                                let anio = hoy.getFullYear();
                                                let mes = hoy.getMonth() + 1;
                                                let dia = hoy.getDate();

                                                dia = ('0' + dia).slice(-2);
                                                mes = ('0' + mes).slice(-2);

                                                let anios = String(anio)
                                                let fechaForm = dia + "" + mes + "" + anios[2] + anios[3];
                                                let fechaForm2 = dia + "/" + mes + "/" + anios[2] + anios[3];
                                                let inicialesInspector = "";

                                                for (let i = 0; i < nombreInspector.length; i++) {
                                                    inicialesInspector += nombreInspector[i][0]
                                                }

                                                for (let i = 0; i < apellidosInspector.length; i++) {
                                                    inicialesInspector += apellidosInspector[i][0]
                                                }

                                                nombreArchivo += solicitud.numerosocio + "-" + values.escrito + "." + anios[2] + anios[3] + fechaForm + inicialesInspector + ".pdf"

                                                let nombregerente = gerente.payload.data.data.titulo + ". " + gerente.payload.data.data.nombre + " " + gerente.payload.data.data.apellidos

                                                const data = {
                                                    numeroDeEscritoComision: values.escrito,
                                                    fecha: fechaForm2,
                                                    nombreDelCliente: solicitud.nombrerazonsocial,
                                                    domicilioDelInstalacion: solicitud.calle + " " + solicitud.numeroexterior + " " + solicitud.municipioalcaldia + " " + solicitud.estado,
                                                    telefono: solicitud.telefono,
                                                    nombreInspector: nombreIns,
                                                    idsolicitudesuifc01: r.payload.data.data.idsolicitudesuifc01,
                                                    idcliente: a.payload.data.data.idcliente,
                                                    nombreArchivo: nombreArchivo,
                                                    reasignar: false,
                                                    idinspector: gerente.payload.data.data.idinspector,
                                                    nombregerente: nombregerente
                                                };
                                                const documento = await fetch(host + 'ArchivosUnidadInspeccion/generarEscritoDeComision', {
                                                    method: 'POST',
                                                    mode: 'cors',
                                                    body: JSON.stringify(data),
                                                    headers: new Headers({
                                                        'Content-Type': 'application/json',
                                                        'Access-Control-Allow-Origin': '*',
                                                    }),
                                                })

                                                if (documento.status != 404) {
                                                    const blob = await documento.blob();
                                                    const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
                                                    //window.open(url);
                                                    setUrlPDF(url)
                                                    let a = document.createElement("a");
                                                    a.href = url;
                                                    a.download = nombreArchivo;
                                                    a.click()
                                                    if (props.isCalendario === false) {
                                                        props.actualizarSolicitudes();
                                                    } else if (props.isCalendario === true) {
                                                        props.actualizarSolicitudes();
                                                        props.handleCloseModalSolicitudes()
                                                    }

                                                    if (props.isZonas === true) {
                                                        props.actualizarSolicitudes()
                                                        props.handleCerrarModalSolicitudes()
                                                    }

                                                    await dispatch(actualizarLoadingApp_false())
                                                } else {

                                                }
                                            })
                                        })
                                    })
                                })
                            }
                            if (props.isCalendario === false) {
                                props.actualizarSolicitudes();
                            } else if (props.isCalendario === true) {
                                props.actualizarSolicitudes();
                                props.handleCloseModalSolicitudes()
                            }

                            if (props.isZonas === true) {
                                props.actualizarSolicitudes()
                                props.handleCerrarModalSolicitudes()
                            }

                            handleCloseModalAsignarInspector()
                        }}
                    >
                        {(props) => (
                            <Form>
                                <InputLabel id="demo-simple-select-label">Numero de Informe</InputLabel>
                                <Field
                                    type="text" className="form-control form-control-sm"
                                    name="folio"
                                />
                                <InputLabel id="demo-simple-select-label">Numero de Escrito de Comisión</InputLabel>
                                <Field
                                    type="text" className="form-control form-control-sm"
                                    name="escrito"
                                />
                                <InputLabel id="demo-simple-select-label">Seleccione un Inspector</InputLabel>
                                <Field
                                    component="select"
                                    id="inspectorseleccionado"
                                    name="inspectorseleccionado"

                                    className="form-select"
                                    multiple={false}
                                    required
                                >
                                    <option defaultValue>Seleccione Inspector</option>
                                    {inspectores.map((inspector, index) => (
                                        <option key={index} value={inspector.idinspector}>{inspector.titulo + " " + inspector.nombre + " " + inspector.apellidos}</option>
                                    ))}
                                </Field>

                                <label className="form-label">Fecha Registro:</label>
                                <br />
                                <LocalizationProvider
                                    dateAdapter={AdapterDateFns}
                                    locale={esLocale}
                                >
                                    <DatePicker
                                        value={fechaSeleccionada}
                                        fullWidth
                                        name="fecha"
                                        onChange={(newValue) => {
                                            setFechaSeleccionada(newValue);
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                fullWidth
                                                sx={styleNormal}
                                                size="small"
                                            />
                                        )}
                                    />
                                </LocalizationProvider><br /><br />
                                {
                                    //<div style={{ textAlign: 'center' }}>
                                    //    <button className='btn btn-success' onClick={() => reagendarSolicitud()}>Guardar</button>
                                    //</div>
                                }

                                <br /><br />
                                <div style={{ textAlign: 'center' }}>
                                    <button type='submit' className='btn btn-success'>Guardar</button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </Box>
            </Modal>
        )
    }

    const modalReagendarSolicitud = () => {
        return (
            <Modal
                open={openModalReagendar}
                onClose={handleCloseModalReagendar}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Reagendar Solicitud
                    </Typography>

                    <div className="col-6">
                        <label className="form-label">Fecha Registro:</label>
                        <br />
                        <LocalizationProvider
                            dateAdapter={AdapterDateFns}
                            locale={esLocale}
                        >
                            <DatePicker
                                value={fechaSeleccionada}
                                fullWidth
                                onChange={(newValue) => {
                                    setFechaSeleccionada(newValue);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        sx={styleNormal}
                                        size="small"
                                    />
                                )}
                            />
                        </LocalizationProvider><br /><br />
                        <div style={{ textAlign: 'center' }}>
                            <button className='btn btn-success' onClick={() => reagendarSolicitud()}>Guardar</button>
                        </div>
                    </div>


                </Box>
            </Modal>
        )
    }

    const handleOpenModalSeleccionarInstalacion = () => {
        setOpenModalSeleccionarInstalacion(true)
    }

    const handleCloseModalSeleccionarInstalacion = () => {
        setOpenModalSeleccionarInstalacion(false);
    }

    const modalSeleccionarInstalacion = () => {
        return (
            <Modal
                open={openModalSeleccionarInstalacion}
                onClose={handleCloseModalSeleccionarInstalacion}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Selecciona la instalación
                    </Typography>
                    <div className='row'>
                        <div key={index} className='col-4'>
                            <button className='btn btn-primary' onClick={() => generarDictamen(1, false)}><strong>Unidad de Producción</strong></button>
                        </div>
                        <div key={index} className='col-4'>
                            <button className='btn btn-primary' onClick={() => generarDictamen(2, false)}><strong>Unidad de Envasado</strong></button>
                        </div>
                        <div key={index} className='col-4'>
                            <button className='btn btn-primary' onClick={() => generarDictamen(3, false)}><strong>Unidad de Almacen</strong></button>
                        </div>
                    </div>

                </Box>
            </Modal>
        )
    }

    const handleOpenModalSeleccionarDocumento = () => {
        setOpenModalSeleccionarDocumento(true)
    }

    const handleCloseModalSeleccionarDocumento = () => {
        setOpenModalSeleccionarDocumento(false);
    }

    const modalSeleccionarDocumento = () => {
        return (
            <Modal
                open={openModalSeleccionarDocumento}
                onClose={handleCloseModalSeleccionarDocumento}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Selecciona el Documento
                    </Typography>
                    <div className='row'>
                        {documentos.map((d) => {
                            let nombre = []
                            //PARA UBUNTU REMPLAZAR POR /
                            nombre = d.ruta.split("/")
                            return (
                                <div key={index} className='col-4'>
                                    <button className='btn btn-primary' onClick={() => visualizarInforme(d.ruta)}><strong>{nombre[nombre.length - 1]}</strong></button>
                                </div>
                            )
                        })}
                    </div>

                </Box>
            </Modal>
        )
    }

    const handleOpenModalSeleccionarDictamen = () => {
        setOpenModalSeleccionarDictamen(true)
    }

    const handleCloseModalSeleccionarDictamen = () => {
        setOpenModalSeleccionarDictamen(false);
    }

    const modalSeleccionarDictamen = () => {
        return (
            <Modal
                open={openModalSeleccionarDictamen}
                onClose={handleCloseModalSeleccionarDictamen}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Seleccione el Dictamen
                    </Typography>
                    <div className='row'>
                        {dictamenes.map((d) => {
                            let nombre = []
                            //PARA UBUNTU REMPLAZAR POR /
                            nombre = d.ruta.split("/")
                            return (
                                <div key={index} className='col-4'>
                                    <button className='btn btn-primary' onClick={() => visualizarDictamen(d.ruta)}><strong>{d.tipodictamen == 1 ? "Producción" : d.tipodictamen == 2 ? "Envasado" : d.tipodictamen == 3 ? "Almacen" : ""}</strong></button>
                                </div>
                            )
                        })}
                    </div>

                </Box>
            </Modal>
        )
    }

    const handleOpenModalPrevisualizar = () => {
        setOpenModalVisualizar(true);
    }
    const handleCloseModalPrevisualizar = () => {
        setOpenModalVisualizar(false);
    }

    const modalPrevisualizarPDF = () => {
        return (
            <div>
                <Modal
                    open={openModalVisualizar}
                    onClose={handleCloseModalPrevisualizar}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={stylePrev}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <div style={{ textAlign: "center" }}>
                                PREVISUALIZACION
                            </div>
                        </Typography>
                        <Box>

                        </Box>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }} height={400}>
                            <div style={{ width: "95%", backgroundColor: "black", height: "55px", position: "absolute" }}>
                            </div>
                            <object
                                data={urlPDF}
                                width="948"
                                height="450"
                            >
                            </object>
                        </Typography>
                        <br />

                    </Box>
                </Modal>
            </div>
        )
    }

    const handleOpenSubirInforme = () => {
        setOpenSubirInforme(true)
    }

    const handleCloseSubirInforme = () => {
        setOpenSubirInforme(false)
    }

    const handleSetInforme = (e) => {
        setInformeSeleccionado(e.target.files[0])
    }

    const subirNuevoInforme = () => {
        if (informeSeleccionado != null) {
            dispatch(getClienteByNumsocio(solicitud.numerosocio)).then(async (a) => {
                const data = {
                    informe: informeSeleccionado,
                    idsolicitudesuifc01: solicitud.solicitudesuifc01[0].idsolicitudesuifc01,
                    idcliente: a.payload.data.data.idcliente
                }
                dispatch(actualizarInforme(data));
                handleCloseSubirInforme()
            })
        } else {
            alert("no se selecciono informe")
        }
    }

    const modalSubirInforme = () => {
        return (
            <Modal
                open={openSubirInforme}
                onClose={handleCloseSubirInforme}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleSubir}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Selecciona el Informe
                    </Typography>
                    <div className='row' style={{ textAlign: "center" }}>
                        <div class="mb-3">
                            <input class="form-control" type="file" id="formFile" accept=".pdf" onChange={(e) => { handleSetInforme(e) }} />
                        </div>
                        <div class="mb-3">
                            <button className='btn btn-success' onClick={subirNuevoInforme}>GUARDAR</button>
                        </div>
                    </div>

                </Box>
            </Modal>
        )
    }

    return (
        <Fragment >

            <div className={renderSolicitud(tipo)}>


                <div className='row card-header text-center' style={{ backgroundColor: colorByStatusSolicitud(solicitud.solicitudesuifc01[0]?.statusdelasolicitud) }}>
                    <div className='col-4'>
                        <p style={{ fontSize: '20px', fontWeight: 'bold' }}> Solicitud ID: {solicitud.idfc01_solicitudregistro} | {solicitud.folio} | {solicitud.informacionmodalaceptada != null ? solicitud.informacionmodalaceptada.numerosolicitudservicios : ""}</p>
                    </div>
                    <div className='col-4'>
                        <h4><strong>{renderTipoSolicitud(solicitud.idestatusdesolicitudes)}</strong></h4>
                    </div>
                    <div className='col-4'>
                        Estatus de la Solicitud: {solicitud.solicitudesuifc01[0]?.statusdelasolicitud == 1 ? "Pendiente" : solicitud.solicitudesuifc01[0]?.statusdelasolicitud == 2 ? "Informe Emitido" : solicitud.solicitudesuifc01[0]?.statusdelasolicitud == 3 ? "Informe en revisión" : solicitud.solicitudesuifc01[0]?.statusdelasolicitud == 4 ? "Dictámen emitido" : solicitud.solicitudesuifc01[0]?.statusdelasolicitud == 5 ? "Completada" : solicitud.solicitudesuifc01[0]?.statusdelasolicitud == 6 ? "Rechazada" : ""}
                        <br />
                        {

                            solicitud.solicitudesuifc01[0]?.statusdelasolicitud === 2 ?

                                <button className='badge btn-warning' onClick={() => actualizarEstado2()}><CheckCircle />Confirmar</button>
                                :
                                solicitud.solicitudesuifc01[0]?.statusdelasolicitud === 3 ?
                                    <button className='badge btn-warning' onClick={() => actualizarEstado3()}><CheckCircle />Confirmar</button>
                                    :
                                    solicitud.solicitudesuifc01[0]?.statusdelasolicitud === 4 ?
                                        <button className='badge btn-warning' onClick={() => actualizarEstado4()}><CheckCircle />Confirmar</button>
                                        :
                                        solicitud.solicitudesuifc01[0]?.statusdelasolicitud === 6 ?
                                            <button className='badge btn-warning' onClick={() => actualizarEstado5()}><CheckCircle />Confirmar</button>
                                            :
                                            <div></div>

                        }
                    </div>
                </div>
                <div className='row'>
                    <div className='col-4'>
                        <p style={{ fontSize: '15px', fontWeight: 'bold', display: 'inline' }}>
                            Estimada para: <strong style={{ fontSize: '15px', display: 'inline' }}>{moment.utc(solicitud.informacionmodalaceptada != null ? solicitud.informacionmodalaceptada.fechainspeccion : solicitud.fechasolicitud).format("LL")}</strong></p><br />
                        <br />
                        <div className='row'>
                            <div className='col-4'>
                                <button className='badge btn-primary' onClick={() => verSolicitud()}><DocumentScannerIcon />Ver Solicitud</button>
                            </div>
                            <div className='col-4'>
                                <button className='badge btn-primary' onClick={() => verEscrito()}><DocumentScannerIcon />Ver Escrito De Comision</button>
                            </div>
                        </div>
                        <div className="row">
                            {
                                solicitud.solicitudesuifc01[0]?.statusdelasolicitud >= 2 ?
                                    <div className='col-4'>
                                        <button className='badge btn-success' onClick={() => verInforme()} ><AssignmentIcon />Ver Informe</button>
                                    </div>
                                    :
                                    <Fragment />
                            }
                            {

                                solicitud.solicitudesuifc01[0]?.statusdelasolicitud === 3 ?
                                    <div className='col-4'>
                                        <button className='badge btn-success' onClick={() => handleOpenSubirInforme()} ><UploadFile />Subir Informe</button>
                                    </div>
                                    :
                                    <Fragment />

                            }
                            {
                                solicitud.solicitudesuifc01[0]?.statusdelasolicitud >= 4 ?
                                    <div className='col-4'>
                                        <button className='badge btn-primary' onClick={() => { verDictamen() }}><DocumentScannerIcon />Ver Dictámen</button>
                                    </div>
                                    :
                                    <Fragment />
                            }
                        </div>


                    </div>
                    <div className='col-4 text-center' style={{ display: 'inline' }}>
                        <p style={{ fontSize: '15px', fontWeight: 'bold', display: 'inline' }}> Atendido por:</p><br />
                        <p style={{ fontSize: '15px', fontWeight: 'bold', textDecoration: 'underline', display: 'inline' }}>{solicitud.revisor}</p><br />
                        <p style={{ fontSize: '15px', fontWeight: 'bold', display: 'inline' }}> Inspector Sugerido Por Atención al Cliente:</p><br />
                        <p style={{ fontSize: '15px', fontWeight: 'bold', display: 'inline', textDecoration: 'underline', color: solicitud.informacionmodalaceptada != null ? '' : 'red' }}> {solicitud.informacionmodalaceptada != null ? solicitud.informacionmodalaceptada.inspectorasignado : "Sin Asignar"}</p><br />
                        <p style={{ fontSize: '15px', fontWeight: 'bold', display: 'inline' }}> Asignado al Inspector:</p><br />
                        <p style={{ fontSize: '15px', fontWeight: 'bold', display: 'inline', textDecoration: 'underline', color: solicitud.solicitudesuifc01.length > 0 ? '' : 'red' }}> {solicitud.solicitudesuifc01.length > 0 ? solicitud.solicitudesuifc01[0]?.inspector.nombre + ' ' + solicitud.solicitudesuifc01[0]?.inspector.apellidos : "Sin Asignar"}</p><br />
                        <p style={{ fontSize: '15px', fontWeight: 'bold', display: 'inline' }}> Observaciones de la Actividad:</p><br />
                        <p style={{ fontSize: '15px', fontWeight: 'bold', display: 'inline', textDecoration: 'underline' }}> {solicitud.solicitudesuifc01.length > 0 ? (solicitud.solicitudesuifc01[0].observaciones != null ? solicitud.solicitudesuifc01[0].observaciones : '') : "Pendiente"}</p>
                    </div>
                    <div className='col-4 text-center' >
                        <p style={{ fontSize: '20px' }}>( {solicitud.numerosocio}) : {solicitud.nombrerazonsocial} <br /></p>
                        <strong style={{ width: '100%', textAlign: 'justify' }}>
                            {solicitud.viverista ? ' | Viverista' : null}
                            {solicitud.productormaguey ? ' | Productor de Maguey' : null}
                            {solicitud.productormezcal ? ' | Productor de Mezcal' : null}
                            {solicitud.envasador ? ' | Envasador' : null}
                            {solicitud.comercializadormezcal ? ' | Comercializador de Mezcal' : null}
                            {solicitud.comercializadorbebidasconmezcal ? ' | Comercializador de Bebidas con Mezcal' : null}
                        </strong>
                        <br /><br />
                        {

                            solicitud.solicitudesuifc01[0]?.statusdelasolicitud == 6 ?
                                <div className='col-4'>
                                    <button className='badge btn-danger' onClick={() => { handleOpenModalTipoInstalacionInforme() }}><DocumentScannerIcon />Corregir Dictamen</button>
                                </div>
                                :
                                <div className='col-4'></div>

                        }
                        <div className='row'>
                            <div className='col-4'>
                                {

                                    solicitud.solicitudesuifc01.length > 0 ?
                                        solicitud.solicitudesuifc01[0]?.statusdelasolicitud === 1 ?
                                            <button onClick={() => handleOpenModalAsignarInspector(2)} className='badge btn-primary'><AccessibilityIcon />Reasignar</button>
                                            :
                                            <div></div>
                                        :
                                        <button onClick={() => handleOpenModalAsignarInspector(1)} className='badge btn-primary'><AccessibilityIcon />Asignar</button>

                                }
                                <br />

                                {
                                    //<button onClick={handleOpenModalReagendar} style={{ marginBottom: '3%', width: '70%' }} className='btn btn-success'><CalendarMonthIcon />Reagendar Visita</button>
                                }
                            </div>
                            {

                                solicitud.solicitudesuifc01[0]?.statusdelasolicitud === 3 ?
                                    <div className='col-4'>
                                        <button className='badge btn-primary' onClick={() => handleOpenModalSeleccionarInstalacion()}><DocumentScannerIcon />Generar Dictámen</button>
                                    </div>
                                    :
                                    <div className='col-4'>
                                    </div>

                            }
                        </div>
                        <br></br>
                    </div>

                </div>
            </div>
            <hr />
            {modalAsignarInspector()}
            {modalReagendarSolicitud()}
            {modalSeleccionarInstalacion()}
            {modalPrevisualizarPDF()}
            {modalSeleccionarDocumento()}
            {modalSeleccionarDictamen()}
            {modalEditarDictamen()}
            {modalSeleccionarInforme()}
            {modalComponentResponsable()}
            {modalSubirInforme()}
            {modalSeleccionarTipoInstalacionInforme()}
        </Fragment>

    );
}

export default withRouter(SolicitudComponent)